import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface AuthContextType {
  isAdmin: boolean;
  isUser: boolean;
  isEmployee:boolean;
  isInstructor:boolean;
  name: string;
  email: string;
  password: string;
  loading: boolean; // <-- NEW
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setName: (name: string) => void;
  login: (role: 'admin' | 'user' |'employee'| 'instructor', email: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isUser, setIsUser] = useState<boolean>(false);
const [isEmployee, setEmployee] = useState<boolean>(false);
const [isInstructor, setInstructor] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const role = localStorage.getItem('role');
    const storedEmail = localStorage.getItem('email');

    if (role === 'admin') {
      setIsAdmin(true);
      setIsUser(false);
      setEmployee(false);
      setInstructor(false);
    } else if (role === 'user') {
      setIsUser(true);
      setIsAdmin(false);
      setEmployee(false);
      setInstructor(false);
    }
    else if (role === 'employee') {
      setIsUser(false);
      setIsAdmin(false);
      setEmployee(true);
      setInstructor(false);
    }
    else if (role === 'instructor') {
      setIsUser(false);
      setIsAdmin(false);
      setEmployee(false);
      setInstructor(true);
    }

    if (storedEmail) setEmail(storedEmail);

    setLoading(false); // <-- mark initialization done
  }, []);
const login = (
  role: string,
  email: string
) => {
  // Normalize role
  const normalizedRole = (role || 'user').toLowerCase() as
    | 'admin'
    | 'user'
    | 'employee'
    | 'instructor';

  // Set flags based on normalized role
  setIsAdmin(normalizedRole === 'admin');
  setIsUser(normalizedRole === 'user');
  setEmployee(normalizedRole === 'employee');
  setInstructor(normalizedRole === 'instructor');

  // Set user info
  setName(name);
  setEmail(email);

  // Store in localStorage
  localStorage.setItem('role', normalizedRole);
  localStorage.setItem('email', email);
};


  const logout = () => {
    setIsAdmin(false);
    setIsUser(false);
    setEmployee(false);
    setInstructor(false);
    setName('');
    setEmail('');
    setPassword('');

    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
  };

  return (
    <AuthContext.Provider
      value={{
        isAdmin,
        isUser,
        isEmployee,
        isInstructor,
        name,
        email,
        password,
        loading, // <-- pass loading
        setEmail,
        setPassword,
        setName,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
